import {Dispatch, SetStateAction} from 'react';

import {FlowTypeEnum} from 'presentation/utils';

export enum BookingNotFoundVariantEnum {
	CITY = 'CITY',
	UF = 'UF',
	SPECIALTY = 'SPECIALTY',
	UNIT = 'UNIT',
	DISTRICT = 'DISTRICT',
	LOCALITY = 'LOCALITY',
}

export type BookingNotFoundDialogProps = {
	variant: BookingNotFoundVariantEnum;
	handleGuideNav: (flowType: FlowTypeEnum) => void;
	handleCallChatRoom: () => void;
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	flowType: FlowTypeEnum;
	firstActionDataTagId?: string;
	secondActionDataTagId?: string;
	headerModalDataTagId?: string;
	closeModalDataTagId?: string;
	callChatRoomIsLoading?: boolean;
};
